/**
 * Última atualização
 */
import * as kApi from "../constants/users_login";
import { Auth } from "aws-amplify";
import { GET_PROD_OR_DEV } from "../constants/api";
import { DEV, FREE, PAID, FONO, BASE_LANG } from "../constants/defaults";
import { CUSTOM_PERMISSIONS } from "../constants/users_login";
import moment from "moment";

// -------------------------------------------------------
// ------ ACOOUNT TYPE FROM URL /login/account_type ------
// -------------------------------------------------------

const getPermissionByAppKey = (permission = null) => {
  if (permission) {
    try {
      permission = JSON.parse(permission);
    } catch (e) {}
    if (permission[kApi.APP_KEY]) permission = permission[kApi.APP_KEY];
  } else {
    //  console.warn("getPermissionByAppKey", "Permission undefined");
  }
  return permission;
};

// Only to login page
export const getPermitionByURL = (userPermission) => {
  switch (userPermission) {
    case kApi.USERTYPE_PRO_FREE:
      return kApi.CUSTOM_START_ACC_TYPE_PRO; //"afinando_v3:pro"
    case kApi.USERTYPE_SINGLE_FREE:
      return kApi.CUSTOM_START_ACC_TYPE_SIN; //"afinando_v3:sin"
    case kApi.USERTYPE_FAMILY_FREE:
      return kApi.CUSTOM_START_ACC_TYPE_FAM; //"afinando_v3:fam"
    default:
      return kApi.CUSTOM_START_ACC_TYPE_SIN; //"afinando_v3:sin"
  }
};
// -------------------------------------------------------

export const getUserAccountType = (userPermission = "") => {
  let notFound = true;
  let position = 0;

  userPermission = getPermissionByAppKey(userPermission);

  while (notFound && position < userPermission.length) {
    if (parseInt(userPermission[position]) === 1) notFound = false;
    else position++;
  }
  return kApi.USERTYPES[position]
    ? kApi.USERTYPES[position]
    : kApi.USERTYPE_SINGLE_FREE;
};

export const checkPaidOrFree = (type = FREE) =>
  type.toLowerCase().trim() === PAID ? true : false;

export const isFree = (permission, plansPerm) => {
  let data = permission;

  // debugger

  if (typeof permission === "string" || permission instanceof String) {
    data = plansPerm;
  }

  if (typeof data === "string") {
    data = JSON.parse(data);
    data = data.afinando_v3;
  }
  // console.log("data.game")
  // console.log(data)
  // console.log(data?.game)

  if (
    (data &&
      data.game &&
      data.game.find((element) => element == "pt-BR") != "pt-BR") ||
    (data && !data.game)
  ) {
    return true;
  } else {
    return false;
  }
};

export const isTrial = (planList) => {
  return planList.reduce((isTrialActive, plan) => {
    return (
      isTrialActive ||
      (plan["status"] === "active" &&
        (plan["category"] === "TRIAL" || plan["payment_method"] === "trial"))
    );
  }, false);
};

export const getUserPermission = () => {
  let permission = { game: ["view"] };

  try {
    if (Auth && "user" in Auth && Auth.user) {
      if (Auth.user.attributes) {
        permission = JSON.parse(Auth.user.attributes[CUSTOM_PERMISSIONS]);
        permission = permission.afinando_v3;
      } else {
        let my_user = Auth.user;
        permission = JSON.parse(
          my_user.signInUserSession.idToken.payload[CUSTOM_PERMISSIONS]
        );
        permission = permission.afinando_v3;
      }
    }
  } catch (error) {
    console.error("Error fetching user permission:", error);
    permission = { game: ["view"] };
  }

  return permission;
};

function arrayUnique(array) {
  var a = array.concat();
  for (var i = 0; i < a.length; ++i) {
    for (var j = i + 1; j < a.length; ++j) {
      if (a[i] === a[j]) a.splice(j--, 1);
    }
  }
  return a;
}

export const getMyActivitiesUserPermission = (
  activeStatus,
  session,
  plansPerm
) => {
  let permission = getUserPermission();

  if ((permission && permission?.game) || session.parentPermission) {
    if (typeof permission === "string" || permission instanceof String) {
      permission = plansPerm;
    }
    if (activeStatus === "false") return permission;
    else {
      permission = {
        game:
          session.parentPermission != ""
            ? arrayUnique(
                permission?.game.concat(session.parentPermission.game)
              )
            : permission?.game,
      };
    }
  } else {
    permission = { game: ["free"] };
  }

  return permission;
};
export const normalizeText = (text) => {
  return text.toLowerCase().replace("-", "_");
};

export const checkPermission = (activity, permission, plansPerm) => {
  let grantPermission = false;
  let newPerm = [];

  if (!activity) return false;

  try {
    if (
      permission &&
      (typeof permission === "string" || permission instanceof String)
    ) {
      permission = JSON.parse(permission);
    }

    if (!permission) {
      permission = plansPerm;
    }

    if (
      permission &&
      plansPerm &&
      permission.hasOwnProperty("game") &&
      plansPerm.hasOwnProperty("game")
    ) {
      permission.game = [...permission.game, ...plansPerm.game]
      permission.game = arrayUnique(permission.game);
    }
  } catch (error) {
    console.error("Erro ao processar permissões:", error);
    permission = plansPerm;
  }

  if (activity.is_free) {
    return true;
  }

  // Verifica se `permission` é um objeto e se contém a propriedade `game` que é um array
  if (permission && Array.isArray(permission.game)) {
    newPerm = [...permission.game];
  } else if (plansPerm && Array.isArray(plansPerm.game)) {
    newPerm = [
      ...newPerm,
      ...plansPerm.game.filter((g) => newPerm.indexOf(g) == -1),
    ];
  } else {
    return (grantPermission = false);
  }

  grantPermission = newPerm.reduce((grant, perm) => {
    return grant || normalizeText(perm) == normalizeText(activity.language);
  }, grantPermission);

  return grantPermission;
};
// -----------------------------------------------
// -----------------------------------------------
// Possible to use with Auth ID or Patient ID
export const hasPermission = (userPermission = "", activityPermission = "") => {
  userPermission = getPermissionByAppKey(userPermission);
  activityPermission = getPermissionByAppKey(activityPermission);
  // console.log("userPermission")

  // console.log(activityPermission)
  let hasPermission = false;

  if (activityPermission && userPermission) {
    let notFound = true;
    let position = 0;

    while (notFound && position < userPermission.length) {
      if (parseInt(userPermission[position]) === 1) notFound = false;
      else position++;
    }

    if (
      activityPermission &&
      activityPermission[position] &&
      parseInt(activityPermission[position]) === 1
    )
      hasPermission = true;
  }
  return hasPermission;
};

// -----------------------------------------------
// -----------------------------------------------
/**
 * @description
 * Check exist Auth.user.attributes
 * Auth && Auth.user && Auth.user.attributes ? true : false;
 */
export const isAuthenticated = (session = null) => {
  // if (GET_PROD_OR_DEV === DEV && Auth && Auth.user && Auth.user.attributes) {
  // console.log("Auth", Auth.user.attributes);
  // console.log("Auth sub", Auth.user.attributes.sub);
  // console.log("Auth jwtToken", Auth.user.signInUserSession.idToken.jwtToken);
  // }
  let user = Auth.user;
  let is_authenticated =
    session ||
    (Auth &&
      Auth.user &&
      (user.attributes ||
        (user.signInUserSession && user.signInUserSession.idToken.payload)))
      ? true
      : false;
  return is_authenticated;
};

export const isUserEven = (session) => {
  let isUserEven = session && session?.my_user.id % 2 === 0 ? true : false;
  return isUserEven;
};

export const hasParent = () => {
  return Auth &&
    Auth.user &&
    ((Auth.user.attributes && Auth.user.attributes[kApi.CUSTOM_PARENT_SUB]) ||
      (Auth.user.signInUserSession &&
        Auth.user.signInUserSession.idToken.payload &&
        Auth.user.signInUserSession.idToken.payload[kApi.CUSTOM_PARENT_SUB]))
    ? true
    : false;
};

export const isUserSingle = () => {
  let isSingle = false;
  if (Auth && Auth.user) {
    const user = Auth.user.attributes
      ? Auth.user.attributes
      : Auth.user.signInUserSession.idToken.payload;
    const account_type = getUserAccountType(user[kApi.CUSTOM_PERMISSIONS]);
    isSingle =
      account_type === kApi.USERTYPE_SINGLE_FREE ||
      account_type === kApi.USERTYPE_SINGLE_PAID;
  }
  return isSingle;
};
export const isUserPro = () => {
  let isPro = false;
  if (Auth && Auth.user) {
    const user = Auth.user.attributes
      ? Auth.user.attributes
      : Auth.user.signInUserSession.idToken.payload;
    const account_type = getUserAccountType(user[kApi.CUSTOM_PERMISSIONS]);
    isPro =
      account_type === kApi.USERTYPE_PRO_FREE ||
      account_type === kApi.USERTYPE_PRO_PAID;
  }
  return isPro;
};

export const isPaid = () => {
  let isPaid = false;
  if (Auth && Auth.user) {
    const user = Auth.user.attributes
      ? Auth.user.attributes
      : Auth.user.signInUserSession.idToken.payload;
    const account_type = getUserAccountType(user[kApi.CUSTOM_PERMISSIONS]);
    isPaid =
      account_type === kApi.USERTYPE_PRO_PAID ||
      account_type === kApi.USERTYPE_SINGLE_PAID ||
      account_type === kApi.USERTYPE_FAMILY_PAID;
  }
  return isPaid;
};

export const getUserTypeToAbility = () => {
  let type = FREE;
  if (Auth && Auth.user) {
    const user = Auth.user.attributes
      ? Auth.user.attributes
      : Auth.user.signInUserSession.idToken.payload;
    const account_type = getUserAccountType(user[kApi.CUSTOM_PERMISSIONS]);
    if (account_type === kApi.USERTYPE_PRO_PAID) type = FONO;
    else if (isPaid()) type = PAID;
    // else if (checkIsFree()) type = "free";
  }
  return type;
};

export const UpdateLocalAmountPlay = (userSub) => {
  console.log("erro novamente");
  //debugger;
  // let userSub = session.sub;
  const curDate = moment().format("YYYY/MM/DD");
  try {
    // if (activeUser && activeUser.sub) {
    //   userSub = activeUser.sub;
    // }
    let userPlay = localStorage.getItem(userSub);
    if (!userPlay) {
      localStorage.setItem(
        userSub,
        JSON.stringify({
          [curDate]: { amount_played_day_add: 1 },
        })
      );
      return 0;
    }
    userPlay = JSON.parse(userPlay);
    if (!userPlay[curDate]) {
      localStorage.setItem(
        userSub,
        JSON.stringify({
          [curDate]: { amount_played_day_add: 1 },
        })
      );
      return 0;
    }
    let propToAdd = "amount_played_day";
    if (userPlay[curDate][propToAdd] === undefined)
      propToAdd = propToAdd + "_add";
    localStorage.setItem(
      userSub,
      JSON.stringify({
        [curDate]: {
          [propToAdd]: userPlay[curDate][propToAdd] + 1,
        },
      })
    );
  } catch (error) {
    console.log("error", error);
  }
};

/**
 * =======================================
 *      Checking Account by SubTypes
 * =======================================
 */

export const isParentPaid = () => isPaid() && !isUserSingle();

/**
 * =======================================
 *      Checking Account By Type
 * =======================================
 */

export const isProPaid = () => {
  let isPaid = false;
  if (Auth && Auth.user) {
    const user = Auth.user.attributes
      ? Auth.user.attributes
      : Auth.user.signInUserSession.idToken.payload;
    const account_type = getUserAccountType(user[kApi.CUSTOM_PERMISSIONS]);
    isPaid = account_type === kApi.USERTYPE_PRO_PAID;
  }
  return isPaid;
};
export const isProFree = () => {
  let isPaid = false;
  if (Auth && Auth.user && Auth.user.attributes) {
    const user = Auth.user.attributes;
    const account_type = getUserAccountType(user[kApi.CUSTOM_PERMISSIONS]);
    isPaid = account_type === kApi.USERTYPE_PRO_FREE;
  }
  return isPaid;
};
export const isSinglePaid = () => {
  let isPaid = false;
  if (Auth && Auth.user) {
    const user = Auth.user.attributes
      ? Auth.user.attributes
      : Auth.user.signInUserSession.idToken.payload;
    const account_type = getUserAccountType(user[kApi.CUSTOM_PERMISSIONS]);
    isPaid = account_type === kApi.USERTYPE_SINGLE_PAID;
  }
  return isPaid;
};

export const isSingleFree = () => {
  let isThisTipe = false;
  if (Auth && Auth.user) {
    const user = Auth.user.attributes
      ? Auth.user.attributes
      : Auth.user.signInUserSession.idToken.payload;
    const account_type = getUserAccountType(user[kApi.CUSTOM_PERMISSIONS]);
    isThisTipe = account_type === kApi.USERTYPE_SINGLE_FREE;
  }
  return isThisTipe;
};
export const isFamilyPaid = () => {
  let isThisTipe = false;
  if (Auth && Auth.user) {
    const user = Auth.user.attributes
      ? Auth.user.attributes
      : Auth.user.signInUserSession.idToken.payload;
    const account_type = getUserAccountType(user[kApi.CUSTOM_PERMISSIONS]);
    isThisTipe = account_type === kApi.USERTYPE_FAMILY_PAID;
  }
  return isThisTipe;
};

export const isFamilyFree = () => {
  let isThisTipe = false;
  if (Auth && Auth.user && Auth.user.attributes) {
    const user = Auth.user.attributes;
    const account_type = getUserAccountType(user[kApi.CUSTOM_PERMISSIONS]);
    isThisTipe = account_type === kApi.USERTYPE_FAMILY_FREE;
  }
  return isThisTipe;
};

export const shouldHideProfileUpdateBanner = (user) => {
  // Oculta o banner quando o usuario ja tem vinculo com responsavel e atividades ativas.
  const parentSub = user?.parent_sub;
  const hasParentSub =
    parentSub !== null &&
    parentSub !== undefined &&
    String(parentSub).trim() !== "";
  const hasParentActivityEnabled =
    String(user?.parent_activity_status) === "true";
  return hasParentSub && hasParentActivityEnabled;
};

export function validarPatternEmail(providor) {
  const sugestoes = {
    "^g.*[ma].*l.[^s@]+$": "gmail.com",
    "^h.*[tm].*l.[^s@]+$": "hotmail.com",
    // "^y.*[aho].*o\.[^\s@]+$": "yahoo.com.br",
    "^o.*[utlo].*k.[^s@]+$": "outlook.com",
    "^i.*[clou].*d.[^s@]+$": "icloud.com",
  };

  for (const regexPattern in sugestoes) {
    const regex = new RegExp(regexPattern);
    if (regex.test(providor) && sugestoes[regexPattern] != providor) {
      return sugestoes[regexPattern];
    }
  }
  return false;
}

export function validarPatternEmailProvidor(providor) {
  const sugestoes = {
    "^gmail.": "gmail.com",
    "^hotmail.": "hotmail.com",
    // "^yahoo\.":"yahoo.com.br",
    "^outlook.": "outlook.com",
    "^icloud.": "icloud.com",
  };

  for (const regexPattern in sugestoes) {
    const regex = new RegExp(regexPattern);
    if (regex.test(providor) && sugestoes[regexPattern] != providor) {
      return sugestoes[regexPattern];
    }
  }

  return false;
}
